/**
 * The three rotating chapter-leadership titles (backend `LeadershipTitle`, TDD 06/09), as sent on
 * `leadershipTitle`, role history and officer changes since 12 October 2026. Before that they were the
 * English words ("Chairman"), shown as they were in every language. Never show the value itself:
 * {@link leadershipTitleKey} turns it into a translation key. The Charter Chairman is the separate
 * `charterChairman` flag, not a title.
 */
export type LeadershipTitle = 'CHAIRMAN' | 'SECRETARY' | 'TREASURER';

/** In the order titles are applied and shown, as on the backend. */
export const LEADERSHIP_TITLES: LeadershipTitle[] = ['CHAIRMAN', 'SECRETARY', 'TREASURER'];

/** COMMON-scope translation key for a title (COMMON is loaded on every screen); '' for none. */
export function leadershipTitleKey(title: LeadershipTitle | string | null | undefined): string {
  return title ? `COMMON.LEADERSHIP_TITLE_${title}` : '';
}

/** Label key for the Charter Chairman flag, next to the titles. */
export const CHARTER_CHAIRMAN_KEY = 'COMMON.CHARTER_CHAIRMAN';
